/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/24/22
 */

import React from "react";
import {Box, Chip, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {eventTypes, getEventType} from "../calendar/event-types";

export interface EventTypeControlProps {
	label?: string
	showTypes?: boolean
	showCategories?: boolean
	values: string[]
	onChange: (types: string[]) => void
	disabled?: boolean
}

export default function EventTypeControl(props: EventTypeControlProps) {

	return (
		<FormControl variant={"standard"} sx={{ minWidth: 150 }}>
			{props.label && <InputLabel>{props.label}</InputLabel>}
			<Select
				multiple
				value={props.values || []}
				disabled={props.disabled}
				onChange={(event) => {
					const types = event.target.value as string[];
					props.onChange(types);
				}}
				renderValue={(selected) => (
					<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .5 }}>
						{selected.map((value) => (
							<Chip
								size={"small"}
								key={value}
								label={getEventType(value)?.name || value}
							/>
						))}
					</Box>
				)}
			>
				{eventTypes.filter(t => ((props.showTypes ?? true) && t.parentId) || ((props.showCategories ?? true) && !t.parentId)).map(type =>
					<MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
				)}
			</Select>
		</FormControl>
	);

}